import BaseCommand from "@/models/api/commands/BaseCommand";
import { CHANGE_REASON } from "@/static/changeReasonEnum";

export interface UpdateCorrectionReasonParams {
  InternalChangeReasonId: CHANGE_REASON | null;
  ChangeReasonDescription: string;
  FormalCorrectionBefore: string | null;
  FormalCorrectionAfter: string | null;
}

export class UpdateCorrectionReasonCommand extends BaseCommand {
  CommandName = "UpdateCorrectionReason";
  Command: UpdateCorrectionReasonParams;
  constructor(sessionId: string, operationId: string, correctionReason: UpdateCorrectionReasonParams) {
    super(sessionId, operationId);
    this.Command = correctionReason;
  }
}
